import MyKeys from "../views/pix/myKeys";
import PaymentLink from "../views/pix/paymentLink";
import PixIcon from "../assets/icons/pixIcon.svg";
import PixIconHover from "../assets/icons/pixIconHover.svg";
import PaperClip from "../assets/icons/link.svg";
import PaperClipHover from "../assets/icons/linkHover.svg";
import mainRouteInterface from "./interfaces/mainRouteInterface";

const routesPayOrder: mainRouteInterface[] = [
    {
        id: "cm7a1",
        path: "/instructions-pix",
        name: "Instruções de Recebimento",
        icon: PixIcon,
        iconHover: PixIconHover,
        layout: "/pix",
        component: MyKeys,
        redirect: false,
    },
    {
        id: "cm7a2",
        path: "/payment-link",
        name: "Gerar Pix",
        icon: PaperClip,
        iconHover: PaperClipHover,
        layout: "/pix",
        component: PaymentLink,
        redirect: false,
    },
];

export default routesPayOrder;
